import { FullStory } from '@fullstory/browser';

export enum AchModalEntryPoint {
  PAYMENT_METHOD = 'Payment method',
  COMPLETED_DWC = 'Completed DWC',
  BANNER = 'Banner',
}

export enum AchModalExitPoint {
  CLOSE_BUTTON = 'Close button',
  GOT_IT_BUTTON = 'Got It button',
}

export const trackAchModalOpened = (modalEntryPoint: AchModalEntryPoint) =>
  FullStory('trackEvent', {
    name: 'ACH Modal Opened',
    properties: { page: 'Status', modalEntryPoint, timestamp: new Date().toISOString() },
  });
export const trackAchModalClosed = (modalExitPoint: AchModalExitPoint) =>
  FullStory('trackEvent', {
    name: 'ACH Modal Opened',
    properties: { page: 'Status', modalExitPoint, timestamp: new Date().toISOString() },
  });
